import { useTranslation } from 'core/i18n';
import {
    PredefinedCommentFormContentWrapper,
    PredefinedCommentWorkflowOverlayComponent,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.style';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PredefinedCommentFormInfo } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/components/predefined-comment-form-info/predefined-comment-form-info.component';
import { PredefinedCommentDeviceTypeList } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/components/predefined-comment-device-type-list/predefined-comment-device-type-list.component';
import { usePredefinedCommentForm } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-form.hook';

export const PredefinedCommentFormContent: React.FC = () => {
    const { t } = useTranslation();
    const {
        formData,
        handleDataChange,
        handleAddDeviceTypeEntry,
        handleRemoveDeviceTypeEntry,
        handleEntryChange,
        handleSave,
        handleEdit,
        unsavedData,
        isDataValid,
        isFormLoading,
        mode,
    } = usePredefinedCommentForm();

    const actionFn = mode === 'add' ? handleSave : handleEdit;

    const hasAnyErroneous = formData.deviceTypeEntries.some((e) => e.erroneous);

    return (
        <PredefinedCommentWorkflowOverlayComponent
            visible
            loading={isFormLoading}
            headerTitle={t(
                mode === 'add'
                    ? 'settings.devices.predefined-comments.form.header.add'
                    : 'settings.devices.predefined-comments.form.header.edit'
            )}
            onClose={() => unsavedData.showUnsavedChangesIfNeededOrClose()}
            className="show-header"
            footer={[
                <PocButton
                    key="save-button"
                    data-testid="predefined-comment-form-save-button"
                    onClick={actionFn}
                    disabled={!isDataValid()}
                >
                    {t(
                        mode === 'add'
                            ? 'settings.devices.predefined-comments.form.button.add'
                            : 'settings.devices.predefined-comments.form.button.save'
                    )}
                </PocButton>,
            ]}
        >
            <PredefinedCommentFormContentWrapper>
                <PredefinedCommentFormInfo
                    commentText={formData.commentText}
                    active={formData.active}
                    hasAnyErroneous={hasAnyErroneous}
                    onCommentTextChange={(value) => handleDataChange('commentText', value)}
                    onActiveChange={(value) => handleDataChange('active', value)}
                />
                <PredefinedCommentDeviceTypeList
                    entries={formData.deviceTypeEntries}
                    onAddEntry={handleAddDeviceTypeEntry}
                    onRemoveEntry={handleRemoveDeviceTypeEntry}
                    onChangeEntry={handleEntryChange}
                />
            </PredefinedCommentFormContentWrapper>
        </PredefinedCommentWorkflowOverlayComponent>
    );
};
